import { DEMO_EVENTS, PERSONAS_BY_ROLE } from '../components/GigPassport/constants/mockData';
import { ARTIST_PROFILES } from './artistProfiles';
import { getTransmissionChronicle, listTransmissionChronicles } from './transmissionChronicles';

const VENUE_DEFINITIONS = {
  'kismat-lounge': {
    id: 'kismat-lounge',
    aliases: ['kismat', 'kismat-washington-heights', 'venue-kismat-washington-heights', 'kismat-stage'],
    name: 'Kismat Washington Heights',
    shortName: 'Kismat Lounge',
    city: 'nyc',
    cityLabel: 'New York City',
    neighborhood: 'Washington Heights · Uptown Manhattan',
    streetAddress: '603 Fort Washington Ave, New York, NY 10033',
    venueType: 'Neighborhood Live Room & Cultural Hub',
    eyebrow: 'Evergreen Venue Node · NYC-01',
    summary:
      'Stewarded by Jeremy as a Washington Heights Cultural Hub and incubator ("Kismat: A Room With a Signal"), Kismat is a neighborhood room anchored by Tuesday Jazz Nights with resident woodwind master Gottfried Stöger, weekly Friday live music and karaoke, working Broadway & Lincoln Center players, and uptown community theater.',
    image: '/images/kismat_washington_heights_signal.png',
    matrixRoomAlias: '#kismat-washington-heights:togeevision.com',
    chronicleId: 'venue-kismat-washington-heights',
    tags: ['Washington Heights', 'Jeremy Steward', 'Tuesday Jazz Night', 'Friday Live Music & Karaoke', 'The Incubator', 'Le Chéile'],
    residentArtists: ['gottfried-stoger', 'monk-washington', 'ed-marshall'],
    upcomingSchedules: [
      {
        id: 'kismat-tuesday-jazz-night',
        title: 'Tuesday Jazz Night at Kismat — Gottfried Stöger & Uptown Ensemble',
        date: 'Tuesdays · Weekly Recurring',
        time: '8:00 PM – 11:00 PM',
        type: 'Weekly Jazz Residency',
        genres: ['Jazz', 'Woodwinds', 'Global Improvisation'],
      },
      {
        id: 'kismat-uptown-friday-2026',
        title: 'Kismat Weekly Friday Live Music & Karaoke Hosted by Jeremy',
        date: 'Fridays · Weekly Recurring',
        time: '8:30 PM – 11:30 PM',
        type: 'Weekly Live Music & Karaoke',
        genres: ['Americana', 'Jazz', 'Karaoke', 'Live Band'],
      },
      {
        id: 'kismat-fri-residency-2026',
        title: 'Kismat Resident Showcase — Gottfried Stöger, Monk Americana & Ed Marshall',
        date: 'Recurring Resident Series',
        time: '8:00 PM – 11:30 PM',
        type: 'Live Showcase',
        genres: ['Woodwinds', 'Americana', 'Visual Archive'],
      },
    ],
    pastGigs: [
      {
        id: 'kismat_past_01',
        title: 'Kismat Washington Heights (with Jeremy) — Field Transmission Chronicle',
        date: '2026 Field Capture',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-kismat-washington-heights',
        artistName: 'Jeremy & Kismat Resident Crew',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-15_midnight_transmission_venue-kismat-washington-heights.mp3',
      },
      {
        id: 'kismat_past_02',
        title: 'Gottfried Stöger — Kismat Resident Woodwinds Signal',
        date: 'May 25, 2026',
        duration: 'Field Chronicle',
        type: 'audio',
        chronicleId: 'artist-gottfried-stoger',
        artistName: 'Gottfried Stöger',
        artistId: 'gottfried-stoger',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-25_evening_transmission_artist-gottfried-stoger.mp3',
      },
      {
        id: 'kismat_past_03',
        title: 'Monk Americana — Live Performance & Rehearsal Fragment',
        date: 'September 9, 2026',
        duration: 'Live Video',
        type: 'video',
        chronicleId: 'artist-monk-washington',
        artistName: 'Monk Americana',
        artistId: 'monk-washington',
        url: 'https://stream.mux.com/ZynH1dnM7e6qJkkvc01P6YXn4CQwG700D4G2xHMgplI3o.m3u8',
      },
      {
        id: 'kismat_past_04',
        title: 'Ed Marshall — Kismat Visual & Sonic Provenance',
        date: 'June 6, 2026',
        duration: 'Field Chronicle',
        type: 'audio',
        chronicleId: 'artist-ed-marshall',
        artistName: 'Ed Marshall',
        artistId: 'ed-marshall',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-06-06_noon_transmission_artist-ed-marshall.mp3',
      },
    ],
  },
  'victoria-nyc': {
    id: 'victoria-nyc',
    aliases: ['victoria', 'victoria-bar', 'venue-victoria-nyc'],
    name: 'Victoria NYC',
    shortName: 'Victoria NYC',
    city: 'nyc',
    cityLabel: 'New York City',
    neighborhood: 'Lower East Side · 235 Eldridge Street',
    streetAddress: '235 Eldridge Street, New York, NY 10002',
    venueType: 'Independent Room & Catalog Session Host',
    eyebrow: 'Evergreen Venue Node · NYC-02',
    summary:
      "235 Eldridge Street coordinate hosting Miwi's Music Thing catalog sessions, acoustic stomp sets, and live field capture.",
    image: '/images/miwi-music-thing-victoria-nyc-2026-09-13.jpg',
    matrixRoomAlias: '#venue-victoria-nyc:togeevision.com',
    chronicleId: 'venue-victoria-nyc',
    tags: ['Lower East Side', 'Live Music', "Miwi's Music Thing", 'Field Transmission'],
    residentArtists: ['monk-washington', 'taylor-hollingsworth', 'anansi-byte'],
    upcomingSchedules: [
      {
        id: 'victoria-miwi-music-thing-sunday',
        title: "Miwi's Music Thing — Sunday Catalog & Live Session (w/ Miwi La Lupa & Guests)",
        date: 'Sundays · Recurring Session',
        time: '4:30 PM – 7:00 PM',
        type: 'Catalog & Songwriter Session',
        genres: ['Indie', 'Americana', 'Songwriter Circle', 'Live Capture'],
      },
      {
        id: 'nyc-activity-victoria-miwi-2026-09-13',
        title: "Miwi's Music Thing & Alex Orange Drink Birthday Sunday Session",
        date: 'September 13, 2026',
        time: '4:30 PM – 7:00 PM',
        type: 'Catalog Session',
        genres: ['Indie', 'Americana', 'Songwriter Circle'],
      },
      {
        id: 'event-taylor-hollingsworth-victoria-nyc-2026-08-23',
        title: 'Taylor Hollingsworth Live at Victoria NYC',
        date: 'August 23, 2026',
        time: '8:00 PM',
        type: 'Live Set',
        genres: ["Folk n' Roll", 'Blues', 'Punk'],
      },
    ],
    pastGigs: [
      {
        id: 'victoria_past_01',
        title: "Victoria NYC — Miwi's Music Thing Field Transmission",
        date: 'September 13, 2026',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-victoria-nyc',
        artistName: 'Miwi La Lupa, Conor Elmes & Monk Americana',
        artistId: 'monk-washington',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/transmission_venue-victoria-nyc.mp3',
      },
    ],
  },
  'melophobe-bk': {
    id: 'melophobe-bk',
    aliases: ['venue-melophobe-bk'],
    name: 'Melophobe BK',
    shortName: 'Melophobe BK',
    city: 'nyc',
    cityLabel: 'New York City',
    neighborhood: 'Brooklyn, NY',
    streetAddress: 'Brooklyn, NY',
    venueType: 'Independent Listening Room & Cultural Space',
    eyebrow: 'Evergreen Venue Node · NYC-03',
    summary: 'Brooklyn cultural listening space hosting Sistagrrrl panels, sonic workshops, and independent showcases.',
    image: '/images/01_newyork.jpg',
    matrixRoomAlias: '#melophobe-bk:togeevision.com',
    chronicleId: null,
    tags: ['Brooklyn', 'Listening Room', 'Sistagrrrl', 'Panel'],
    residentArtists: ['honeychild-coleman', 'anansi-byte'],
    upcomingSchedules: [
      {
        id: 'demo-event-nyc-sistagrrrl-panel-2026',
        title: 'Sistagrrrl Riots Archival Panel & Live Dub Session',
        date: 'June 20, 2026',
        time: '8:00 PM',
        type: 'Panel & Showcase',
        genres: ['Post-Punk', 'Dub', 'Oral History'],
      },
    ],
    pastGigs: [],
  },
  'film-forum-nyc': {
    id: 'film-forum-nyc',
    aliases: ['film-forum', 'venue-film-forum-nyc', 'venue-film-forum', 'a-train-film-forum', 'once-upon-a-time-in-harlem'],
    name: 'Film Forum',
    shortName: 'Film Forum',
    city: 'nyc',
    cityLabel: 'New York City',
    neighborhood: 'West Village / Hudson Square · 209 West Houston Street',
    streetAddress: '209 West Houston St, New York, NY 10014',
    venueType: 'Nonprofit Independent Cinema & Cultural Archive Node',
    eyebrow: 'Evergreen Venue Node · NYC-04',
    summary:
      "209 West Houston Street repertory and documentary cinema node linked via the Eighth Avenue A Train corridor from Harlem (125th St to West 4th St), screening William Greaves's 1972 masterpiece Once Upon A Time in Harlem and preserving the James Reese Europe origin lore of the word 'gig.'",
    image: '/images/transmissions/nyc/film-forum-once-upon-a-time-in-harlem-marquee.jpg',
    matrixRoomAlias: '#venue-film-forum-nyc:togeevision.com',
    chronicleId: 'venue-film-forum-nyc',
    tags: ['West Houston', 'Film Forum', 'Once Upon A Time in Harlem', 'The A Train', 'Origin of Gig', 'Field Transmission'],
    residentArtists: ['anansi-byte'],
    upcomingSchedules: [
      {
        id: 'film-forum-once-upon-a-time-in-harlem-2026',
        title: "Once Upon A Time in Harlem (William Greaves, 1972) — 'A House Party for the Ages'",
        date: 'October 2026 Repertory Run',
        time: 'Evening Screenings',
        type: 'Documentary Screening & Field Archive',
        genres: ['Harlem Renaissance', 'Documentary', 'Jazz Lineage', 'Oral History'],
      },
    ],
    pastGigs: [
      {
        id: 'film_forum_past_01',
        title: "The A Train to Film Forum: Once Upon A Time in Harlem & The Origin of 'Gig'",
        date: 'October 18, 2026',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-film-forum-nyc',
        artistName: 'William Greaves, Eubie Blake, Noble Sissle & TogeeVision Field Unit',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-film-forum-nyc.mp3',
      },
    ],
  },
  'nomaa-gallery-nyc': {
    id: 'nomaa-gallery-nyc',
    aliases: ['nomaa-gallery', 'venue-nomaa-gallery-nyc', 'venue-nomaa-gallery', 'venue-nomaa', 'nomaa-nyc', 'nomaa', 'dear-earth-love-uptown', 'aqui-me-quedo'],
    name: 'NoMAA Gallery (Northern Manhattan Arts Alliance)',
    shortName: 'NoMAA Gallery',
    city: 'nyc',
    cityLabel: 'New York City',
    neighborhood: 'Washington Heights · 4140 Broadway (at 176th St)',
    streetAddress: '4140 Broadway, 1st Floor, New York, NY 10033',
    venueType: 'Uptown Cultural Gallery & Arts Alliance Node',
    eyebrow: 'Evergreen Venue Node · NYC-06',
    summary:
      "4140 Broadway (at 176th Street) Uptown gallery coordinate hosting 'Dear Earth… Love, Uptown' (29 West Harlem, Washington Heights, and Inwood artists) and Paula Maria Persiani's 'Aquí Me Quedo — Los Cepeda' (Loíza, Puerto Rico).",
    image: '/images/transmissions/nyc/paula-maria-persiani-aqui-me-quedo-loiza.png',
    matrixRoomAlias: '#venue-nomaa-gallery-nyc:togeevision.com',
    chronicleId: 'venue-nomaa-gallery-nyc',
    tags: ['Washington Heights', 'NoMAA Gallery', 'Dear Earth Love Uptown', 'Paula Maria Persiani', 'Aquí Me Quedo', 'Los Cepeda', 'Loíza'],
    residentArtists: ['paula-maria-persiani'],
    upcomingSchedules: [
      {
        id: 'nomaa-dear-earth-love-uptown-2026',
        title: "Dear Earth… Love, Uptown — Exhibition & Field Archive (feat. Paula Maria Persiani 'Aquí Me Quedo — Los Cepeda')",
        date: 'October 22 – December 2026',
        time: 'Gallery Hours & Community Receptions',
        type: 'Visual Art Exhibition & Field Archive',
        genres: ['Visual Art', 'Nuyorican / Diasporican', 'Ecological Sovereignty', 'Loíza Lineage'],
      },
    ],
    pastGigs: [
      {
        id: 'nomaa_past_01',
        title: "NoMAA Gallery: 'Dear Earth… Love, Uptown' & Paula Maria Persiani's 'Aquí Me Quedo — Los Cepeda'",
        date: 'October 22, 2026',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-nomaa-gallery-nyc',
        artistName: 'Paula Maria Persiani & NoMAA Uptown Artists',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-nomaa-gallery-nyc.mp3',
      },
    ],
  },
  'pianos-nyc': {
    id: 'pianos-nyc',
    aliases: ['pianos', 'venue-pianos-nyc', 'pianos-on-ludlow', 'pianos (ludlow st)', 'pianos nyc', 'venue-pianos', 'i-have-a-dream-pop-festival', 'i-have-a-dream-pop', 'the-veldt'],
    name: 'Pianos',
    shortName: 'Pianos',
    city: 'nyc',
    cityLabel: 'New York City',
    neighborhood: 'Lower East Side · 158 Ludlow Street',
    streetAddress: '158 Ludlow St, New York, NY 10002',
    venueType: 'Lower East Side Live Room & Cultural Anchor',
    eyebrow: 'Evergreen Venue Node · NYC-05',
    summary:
      "158 Ludlow Street Lower East Side live music coordinate hosting the 'I Have A Dream Pop Festival' founded by Daniel and Danny Chavis of Afro-futurist soul-shoegaze pioneers The Veldt—featuring Friday night Showroom sets by The Veldt, Diary, Day & Dream, and Darksoft.",
    image: '/images/transmissions/nyc/pianos-the-veldt-chavis-vox-phantom.jpg',
    matrixRoomAlias: '#venue-pianos-nyc:togeevision.com',
    chronicleId: 'venue-pianos-nyc',
    tags: ['Lower East Side', 'Pianos', 'I Have A Dream Pop Festival', 'The Veldt', 'Diary', 'Day & Dream', 'Darksoft'],
    residentArtists: ['honeychild-coleman', 'monk-washington', 'the-veldt'],
    upcomingSchedules: [
      {
        id: 'i-have-a-dream-pop-festival-pianos-2026-10-23',
        title: "I Have A Dream Pop Festival — The Veldt, Diary, Day & Dream & Darksoft",
        date: 'Friday Oct 23, 2026',
        time: '7:00 PM – 1:00 AM',
        type: 'LIVE_MUSIC',
        genres: ['Shoegaze', 'Dream Pop', 'Afro-Futurist Soul', 'Post-Punk'],
      },
      {
        id: 'honeychild-coleman-with-monk-americana-n36wnssh',
        title: 'Honeychild Coleman accompanied by Monk Americana',
        date: 'Saturday Oct 24, 2026',
        time: '8:30 PM',
        type: 'LIVE_MUSIC',
        genres: ['Blues', 'Punk', 'Americana', 'Live Band'],
      },
    ],
    pastGigs: [
      {
        id: 'pianos-honeychild-dem-monk-2026-10-24',
        title: "I Have A Dream Pop Festival (Saturday): HoneyChild's DEM w/ Monk Americana & Jennie Oliver-Cretara ('The Salt')",
        date: 'October 24, 2026',
        type: 'chronicle',
        chronicleId: 'artist-honeychild-coleman',
        artistName: "Honeychild Coleman (HoneyChild's DEM), Monk Americana & Jennie Oliver-Cretara",
        artistId: 'honeychild-coleman',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
      },
      {
        id: 'pianos-honeychild-dem-video-clip-1-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip I)",
        date: 'October 24, 2026',
        duration: 'Live Stage Video',
        type: 'video',
        chronicleId: 'artist-honeychild-coleman',
        artistName: "Honeychild Coleman (HoneyChild's DEM) & Monk Americana",
        artistId: 'honeychild-coleman',
        url: 'https://docs.google.com/videos/d/1qHQEHzuGGaaraJjhmIyjaZRXo0hxPN8xpSgkl3_zEOI/play?usp=sharing',
      },
      {
        id: 'pianos-honeychild-dem-video-clip-2-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana & Jennie Oliver-Cretara — 'The Salt' Live at Pianos NYC (Saturday Night Clip II)",
        date: 'October 24, 2026',
        duration: '4K Live Stage Video',
        type: 'video',
        chronicleId: 'artist-honeychild-coleman',
        artistName: "Honeychild Coleman (HoneyChild's DEM), Monk Americana & Jennie Oliver-Cretara",
        artistId: 'honeychild-coleman',
        url: 'https://docs.google.com/videos/d/1DxnuNZmyvx6XaJJEPIGwuq_Q4UY5-RKzt6WBxmgMyvA/play?usp=sharing',
      },
      {
        id: 'pianos-honeychild-dem-video-clip-3-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip III)",
        date: 'October 24, 2026',
        duration: 'Live Stage Video',
        type: 'video',
        chronicleId: 'artist-honeychild-coleman',
        artistName: "Honeychild Coleman (HoneyChild's DEM) & Monk Americana",
        artistId: 'honeychild-coleman',
        url: 'https://docs.google.com/videos/d/1CYlQdBHyrkXJM_UVtJpzTLSPyVUCbCotMknqgZW8aFQ/play?usp=sharing',
      },
      {
        id: 'pianos-honeychild-dem-video-clip-4-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip IV)",
        date: 'October 24, 2026',
        duration: 'Live Stage Video',
        type: 'video',
        chronicleId: 'artist-honeychild-coleman',
        artistName: "Honeychild Coleman (HoneyChild's DEM) & Monk Americana",
        artistId: 'honeychild-coleman',
        url: 'https://docs.google.com/videos/d/13VF0mI1ljMCaahOQ9XnE4KgscByzYxdPAi0pFqwI9Ok/play?usp=sharing',
      },
      {
        id: 'pianos-i-have-a-dream-pop-festival-2026-10-23',
        title: "I Have A Dream Pop Festival: The Veldt ('Christine'), Diary, Day & Dream & Darksoft Live Capture",
        date: 'October 23, 2026',
        type: 'chronicle',
        chronicleId: 'venue-pianos-nyc',
        artistName: 'The Veldt, Diary, Day & Dream & Darksoft',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-pianos-nyc.mp3',
      },
      {
        id: 'pianos-the-veldt-friday-showroom-video-2026-10-23',
        title: "The Veldt Live at Pianos NYC Showroom — 'I Have A Dream Pop Festival' (Friday Night Video)",
        date: 'October 23, 2026',
        duration: 'Live Video',
        type: 'video',
        chronicleId: 'venue-pianos-nyc',
        artistName: 'The Veldt',
        artistId: 'the-veldt',
        url: 'https://drive.google.com/file/d/1Kp1Aqz6k-DKRYmi917TsQRHjVGd3-kL7/view?usp=drive_link',
      },
    ],
  },
  'venue-turbo-haus-montreal': {
    id: 'venue-turbo-haus-montreal',
    aliases: ['turbo-haus', 'bily-kun'],
    name: 'Turbo Haus',
    shortName: 'Turbo Haus',
    city: 'montreal',
    cityLabel: 'Montréal',
    neighborhood: 'Quartier Latin · Saint-Denis',
    streetAddress: '2040 St Denis St, Montreal, QC H2X 3K7',
    venueType: 'Underground Live Room & DIY Anchor',
    eyebrow: 'Evergreen Venue Node · MTL-01',
    summary:
      'Saint-Denis DIY live room documented for its live band karaoke finale, Neon oral history on gentrification and venue resilience, and Plateau corridor ties.',
    image: '/images/place_des_festivals_jazz.jpg',
    matrixRoomAlias: '#montreal-radar:togeevision.com',
    chronicleId: 'venue-turbo-haus-montreal',
    tags: ['Montréal', 'Saint-Denis', 'DIY Venue', 'Live Band Karaoke'],
    residentArtists: [],
    upcomingSchedules: [
      {
        id: 'turbo-haus-live-karaoke',
        title: 'Saint-Denis Live Band Showcase & DIY Night',
        date: 'Monthly Residency · 2026',
        time: '9:30 PM',
        type: 'Live Showcase',
        genres: ['Punk', 'Indie Rock', 'Live Karaoke'],
      },
    ],
    pastGigs: [
      {
        id: 'turbo_past_01',
        title: 'Turbo Haus Live Band Karaoke Finale & Neon Interview',
        date: '2026 Field Capture',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-turbo-haus-montreal',
      },
    ],
  },
  'venue-lescogriffe-montreal': {
    id: 'venue-lescogriffe-montreal',
    aliases: ['lescogriffe', 'bar-lescogriffe'],
    name: "Bar L'Escogriffe",
    shortName: "L'Escogriffe",
    city: 'montreal',
    cityLabel: 'Montréal',
    neighborhood: 'Plateau-Mont-Royal · Saint-Denis',
    streetAddress: '4461 St Denis St, Montreal, QC H2J 2L2',
    venueType: 'Underground Rock Club',
    eyebrow: 'Evergreen Venue Node · MTL-02',
    summary:
      "Plateau underground rock club hosting béatitude & Le bon vent album launches and late-night Saint-Denis corridor transmissions.",
    image: '/images/place_des_festivals_jazz.jpg',
    matrixRoomAlias: '#montreal-radar:togeevision.com',
    chronicleId: 'venue-lescogriffe-montreal',
    tags: ['Montréal', 'Plateau', 'Saint-Denis', 'Album Launch'],
    residentArtists: [],
    upcomingSchedules: [
      {
        id: 'lescogriffe-plateau-session',
        title: 'Plateau Underground Showcase',
        date: 'Summer / Fall 2026',
        time: '9:00 PM',
        type: 'Live Set',
        genres: ['Progressive Rock', 'Francophone Indie'],
      },
    ],
    pastGigs: [
      {
        id: 'lesco_past_01',
        title: 'béatitude & Le bon vent Album Launch Capture',
        date: '2026 Field Capture',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-lescogriffe-montreal',
      },
    ],
  },
  'venue-minute-mapp-montreal': {
    id: 'venue-minute-mapp-montreal',
    aliases: ['minute-mapp', 'mapp-mtl', 'van-horne-skatepark'],
    name: 'MAPP MTL (Van Horne)',
    shortName: 'MAPP MTL',
    city: 'montreal',
    cityLabel: 'Montréal',
    neighborhood: 'Mile End · Van Horne Viaduct',
    streetAddress: 'Van Horne Skatepark, Montreal, QC',
    venueType: 'Architectural Projection & Public Art Node',
    eyebrow: 'Evergreen Venue Node · MTL-03',
    summary:
      'CROSSROADS 60-second architectural projection mapping at the Million Carpets and Tiles facade and Van Horne Skatepark.',
    image: '/images/place_des_festivals_jazz.jpg',
    matrixRoomAlias: '#montreal-radar:togeevision.com',
    chronicleId: 'venue-minute-mapp-montreal',
    tags: ['Montréal', 'Mile End', 'Projection Mapping', 'Public Art'],
    residentArtists: [],
    upcomingSchedules: [],
    pastGigs: [
      {
        id: 'mapp_past_01',
        title: 'MINUTE_MAPP CROSSROADS Projection Capture',
        date: '2026 Field Capture',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-minute-mapp-montreal',
      },
    ],
  },
  steelstacks: {
    id: 'steelstacks',
    aliases: ['venue-steelstacks', 'musikfest', 'barton-street-grill', 'trexlertown-velodrome'],
    name: 'SteelStacks · Bethlehem',
    shortName: 'SteelStacks',
    city: 'lehigh-valley',
    cityLabel: 'Lehigh Valley',
    neighborhood: 'Bethlehem · SouthSide Arts District',
    streetAddress: '101 Founders Way, Bethlehem, PA 18015',
    venueType: 'Industrial Arts Campus & Festival Stage',
    eyebrow: 'Evergreen Venue Node · LVPA-01',
    summary:
      'Post-industrial blast furnace campus anchoring Lehigh Valley live music, Musikfest performances, and regional field transmissions.',
    image: '/images/tvisio_logo.webp',
    matrixRoomAlias: '#lehigh-valley-radar:togeevision.com',
    chronicleId: 'venue-steelstacks',
    tags: ['Lehigh Valley', 'Bethlehem', 'Industrial Arts', 'Festival Anchor'],
    residentArtists: [],
    upcomingSchedules: [
      {
        id: 'musikfest-2026-showcase',
        title: 'Lehigh Valley Signal Showcase at SteelStacks',
        date: 'August 2026',
        time: '7:30 PM',
        type: 'Festival Stage',
        genres: ['Roots', 'Jazz', 'Independent'],
      },
    ],
    pastGigs: [
      {
        id: 'steelstacks_past_01',
        title: 'SteelStacks Industrial Horizon Field Transmission',
        date: '2026 Field Capture',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-steelstacks',
      },
    ],
  },
  'parcel-5': {
    id: 'parcel-5',
    aliases: ['venue-parcel-5', 'venue-the-church-rochester', 'the-church-rochester', 'the-church', 'hallock-lounge', 'rochester-fringe-festival', 'fringe-festival', 'one-fringe-place'],
    name: 'The Church (Hallock Lounge) & Rochester Fringe Grounds',
    shortName: 'The Church / Rochester Fringe',
    city: 'rochester',
    cityLabel: 'Rochester',
    neighborhood: 'Downtown Fitzhugh & Main Street Corridor, Rochester, NY',
    streetAddress: '121 N Fitzhugh St, Rochester, NY 14614',
    venueType: 'Rochester Fringe Performance Room & Festival Grounds',
    eyebrow: 'Evergreen Venue Node · ROC-01',
    summary:
      'Downtown United Presbyterian Church (Hallock Lounge) and Rochester Fringe Festival corridor where Mister Aubs and his collaborator trio performed live on Thursday, September 24, 2026.',
    image: '/images/transmissions/rochester-fringe/mister-aubs-live-performance.jpg',
    imagePosition: 'center top',
    matrixRoomAlias: '#rochester-fringe:togeevision.com',
    chronicleId: 'venue-parcel-5',
    tags: ['Rochester', 'Fringe Festival', 'The Church', 'Hallock Lounge', 'Mister Aubs'],
    residentArtists: ['azariah'],
    upcomingSchedules: [],
    pastGigs: [
      {
        id: 'rochester_the_church_mister_aubs_2026_09_24',
        title: 'Mister Aubs Live at The Church (Hallock Lounge) — Rochester Fringe Festival',
        date: 'September 24, 2026 · 7:00 PM – 8:00 PM',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-parcel-5',
      },
    ],
  },
  'venue-house-of-rastafari': {
    id: 'venue-house-of-rastafari',
    aliases: ['house-of-rastafari', 'venue-rototom-main', 'rototom-main-stage'],
    name: 'House of Rastafari · Rototom Sunsplash',
    shortName: 'House of Rastafari',
    city: 'rtm',
    cityLabel: 'Rototom Sunsplash (Benicàssim)',
    neighborhood: 'Recinto de Festivales · Benicàssim, Spain',
    streetAddress: 'Recinto de Festivales, Benicàssim, Spain',
    venueType: 'Cultural Forum & Festival Stage',
    eyebrow: 'Evergreen Venue Node · RTM-01',
    summary:
      'Roots, reasoning, nyabinghi drumming, and international reggae lineage documented at Rototom Sunsplash.',
    image: '/images/tvisio_logo.webp',
    matrixRoomAlias: '#rtm-tracking:togeevision.com',
    chronicleId: 'venue-house-of-rastafari',
    tags: ['Rototom Sunsplash', 'Roots', 'Oral History', 'Field Transmission'],
    residentArtists: [],
    upcomingSchedules: [],
    pastGigs: [
      {
        id: 'rtm_past_01',
        title: 'House of Rastafari Field Transmission',
        date: '2026 Field Capture',
        duration: 'Field Transmission',
        type: 'chronicle',
        chronicleId: 'venue-house-of-rastafari',
      },
    ],
  },
};

const ALIAS_LOOKUP = (() => {
  const map = new Map();
  const slugify = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  for (const [key, def] of Object.entries(VENUE_DEFINITIONS)) {
    map.set(key.toLowerCase(), def);
    map.set(slugify(key), def);
    if (def.name) {
      map.set(def.name.toLowerCase(), def);
      map.set(slugify(def.name), def);
    }
    if (def.shortName) {
      map.set(def.shortName.toLowerCase(), def);
      map.set(slugify(def.shortName), def);
    }
    for (const alias of def.aliases || []) {
      map.set(alias.toLowerCase(), def);
      map.set(slugify(alias), def);
    }
  }
  return map;
})();

export function resolveVenueProfile(rawSlug) {
  if (!rawSlug) return null;
  const clean = String(rawSlug).trim().toLowerCase();
  const slugified = clean.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const stripped = clean.replace(/^venue-/, '');
  const strippedSlug = slugified.replace(/^venue-/, '');

  const matched =
    ALIAS_LOOKUP.get(clean) ||
    ALIAS_LOOKUP.get(slugified) ||
    ALIAS_LOOKUP.get(stripped) ||
    ALIAS_LOOKUP.get(strippedSlug) ||
    ALIAS_LOOKUP.get(`venue-${stripped}`) ||
    ALIAS_LOOKUP.get(`venue-${strippedSlug}`);
  if (matched) {
    const chronicle = matched.chronicleId ? getTransmissionChronicle(matched.chronicleId) : getTransmissionChronicle(clean);
    const demoEvents = DEMO_EVENTS.filter((ev) => {
      const evVenueId = String(ev.venueId || '').toLowerCase();
      const evVenueName = String(ev.venue || '').toLowerCase();
      return evVenueId === matched.id
        || (matched.aliases || []).includes(evVenueId)
        || evVenueName.includes(matched.shortName.toLowerCase());
    });
    const mergedUpcoming = [
      ...matched.upcomingSchedules,
      ...demoEvents
        .filter((ev) => !matched.upcomingSchedules.some((u) => u.id === ev.id))
        .map((ev) => ({
          id: ev.id,
          title: ev.title,
          date: ev.date,
          time: ev.time || 'Evening Set',
          type: ev.type || 'Live Event',
          genres: ev.genres || [],
        })),
    ];
    const residentArtistProfiles = (matched.residentArtists || [])
      .map((artistId) => ARTIST_PROFILES[artistId])
      .filter(Boolean);

    return {
      ...matched,
      requestedSlug: clean,
      chronicle,
      upcomingSchedules: mergedUpcoming,
      residentArtistProfiles,
    };
  }

  // Check mockData 'Venue Owner' personas or transmissionChronicles for any other dynamic venue slug
  const personaVenue = (PERSONAS_BY_ROLE['Venue Owner'] || []).find(
    (p) => p.id.toLowerCase() === clean || p.id.toLowerCase() === `venue-${stripped}`
  );
  const dynamicChronicle = getTransmissionChronicle(clean) || getTransmissionChronicle(`venue-${stripped}`);

  if (personaVenue || dynamicChronicle) {
    const id = personaVenue?.id || dynamicChronicle?.id || clean;
    const name = personaVenue?.name || dynamicChronicle?.subject || rawSlug.replace(/[-_]+/g, ' ');
    const city = personaVenue?.city || dynamicChronicle?.city || 'nyc';
    return {
      id,
      aliases: [clean],
      name,
      shortName: name,
      city,
      cityLabel: city.toUpperCase(),
      neighborhood: personaVenue?.neighborhood || dynamicChronicle?.eyebrow || 'Local Signal Corridor',
      streetAddress: personaVenue?.address || `${city.toUpperCase()} Cultural Node`,
      venueType: personaVenue?.genre || 'Independent Venue Node',
      eyebrow: `Evergreen Venue Node · ${city.toUpperCase()}`,
      summary:
        personaVenue?.bio ||
        dynamicChronicle?.summary ||
        `${name} is an active venue node in the TogeeVision signal field. One QR code follows all past, live, and future events here.`,
      image: dynamicChronicle?.image || '/images/tvisio_logo.webp',
      matrixRoomAlias: `#${stripped}:togeevision.com`,
      chronicleId: dynamicChronicle?.id || null,
      chronicle: dynamicChronicle || null,
      tags: [city.toUpperCase(), 'Venue Node', 'Gig Passport'],
      residentArtists: [],
      residentArtistProfiles: [],
      upcomingSchedules: DEMO_EVENTS.filter((ev) => String(ev.venueId || '').toLowerCase() === id.toLowerCase()).map(
        (ev) => ({
          id: ev.id,
          title: ev.title,
          date: ev.date,
          time: ev.time || 'Evening Set',
          type: ev.type || 'Live Event',
          genres: ev.genres || [],
        })
      ),
      pastGigs: dynamicChronicle
        ? [
            {
              id: `${id}_chronicle`,
              title: dynamicChronicle.title || dynamicChronicle.subject,
              date: 'Field Transmission',
              duration: 'Chronicle',
              type: 'chronicle',
              chronicleId: dynamicChronicle.id,
            },
          ]
        : [],
    };
  }

  // Fallback synthetic evergreen venue profile so any newly onboarded venue slug works immediately
  const formattedName = stripped
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
  return {
    id: clean,
    aliases: [clean, stripped],
    name: formattedName || 'Local Venue Node',
    shortName: formattedName || 'Venue Node',
    city: 'nyc',
    cityLabel: 'Signal Field',
    neighborhood: 'Independent Venue Circuit',
    streetAddress: 'Verified TogeeVision Venue Node',
    venueType: 'Evergreen Venue Node',
    eyebrow: 'Evergreen Venue Node',
    summary: `${formattedName || 'This venue'} is registered on the TogeeVision Signal Radar. This single evergreen QR tracks all past archives, live broadcasts, and upcoming events at this location.`,
    image: '/images/tvisio_logo.webp',
    matrixRoomAlias: `#${stripped || 'venue'}:togeevision.com`,
    chronicleId: null,
    chronicle: null,
    tags: ['Live Venue', 'Signal Radar', 'Gig Passport'],
    residentArtists: [],
    residentArtistProfiles: [],
    upcomingSchedules: [],
    pastGigs: [],
    isFallback: true,
  };
}

export function listAllVenueProfiles() {
  const seen = new Set();
  const list = [];
  for (const def of Object.values(VENUE_DEFINITIONS)) {
    if (!seen.has(def.id)) {
      seen.add(def.id);
      list.push(resolveVenueProfile(def.id));
    }
  }
  for (const chronicle of listTransmissionChronicles()) {
    if (chronicle.sourceType === 'venue' && !seen.has(chronicle.id)) {
      const resolved = resolveVenueProfile(chronicle.id);
      if (resolved && !seen.has(resolved.id)) {
        seen.add(resolved.id);
        list.push(resolved);
      }
    }
  }
  return list;
}

export function resolveVenueCalendarRoute(venueInput) {
  if (!venueInput) return '/passport/radar';
  if (typeof venueInput === 'string') {
    const clean = venueInput.trim().toLowerCase();
    if (clean.includes('kismat')) return '/kismat';
    const resolved = resolveVenueProfile(clean);
    if (resolved && !resolved.isFallback) {
      return resolved.id === 'kismat-lounge' ? '/kismat' : `/venues/${resolved.id}`;
    }
    const slug = clean.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return slug ? `/venues/${slug}` : '/passport/radar';
  }

  const firstSignal = Array.isArray(venueInput.activeSignals) ? venueInput.activeSignals[0] : null;
  const candidates = [
    venueInput.id,
    venueInput.venueId,
    venueInput.name,
    venueInput.venue,
    firstSignal?.venueId,
    firstSignal?.venue,
  ].filter(Boolean);

  for (const candidate of candidates) {
    const clean = String(candidate).trim().toLowerCase();
    if (clean.includes('kismat')) return '/kismat';
    const resolved = resolveVenueProfile(clean);
    if (resolved && !resolved.isFallback) {
      return resolved.id === 'kismat-lounge' ? '/kismat' : `/venues/${resolved.id}`;
    }
  }

  const fallbackRaw = String(candidates[0] || '').trim().toLowerCase();
  const fallbackSlug = fallbackRaw.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return fallbackSlug ? `/venues/${fallbackSlug}` : '/passport/radar';
}

